import React, { useEffect } from 'react';
import {
  handleLoginHelper,
  handleSignupHelper,
} from '../../setup/utilsV3/buttonFactoryUtils';
import { trackEventWithData } from '../../setup/utilsV3/analytics';
import { FPTI_SPEC } from '../../setup/utilsV3/fptiConstants';
import { useSelector } from 'react-redux';

function GlobalNavHeader(props) {
  const headerHtml = useSelector(
    (state) => state?.application?.globalNavHeaderHtml
  );

  const loginHandler = (event) => {
    event.preventDefault();
    trackEventWithData(FPTI_SPEC.LANDING_PAGE_HEADER_LOGIN_CL);
    handleLoginHelper(props.history);
  };

  const signupHandler = (event) => {
    event.preventDefault();
    trackEventWithData(FPTI_SPEC.LANDING_PAGE_HEADER_SIGNUP_CL);
    handleSignupHelper(props.history);
  };

  const addEventListenerList = (list, event, fn) => {
    for (let i = 0, len = list.length; i < len; i++) {
      list[i].addEventListener(event, fn);
    }
  };

  const removeEventListenerList = (list, event, fn) => {
    for (let i = 0, len = list.length; i < len; i++) {
      list[i].removeEventListener(event, fn);
    }
  };

  useEffect(() => {
    const loginButton = document.querySelector('a[href="/signin"]');
    const signupButtons = document.querySelectorAll(
      'a[href*="/us/webapps/mpp/account-selection"]'
    );

    if (!!loginButton && !!signupButtons && signupButtons.length > 0) {
      loginButton.addEventListener('click', loginHandler);
      addEventListenerList(signupButtons, 'click', signupHandler);

      return () => {
        loginButton.removeEventListener('click', loginHandler);
        removeEventListenerList(signupButtons, 'click', signupHandler);
      };
    }
  }, []);

  return (
    <>
      {headerHtml && (
        <>
          <div
            dangerouslySetInnerHTML={{
              __html: headerHtml,
            }}
          />
        </>
      )}
    </>
  );
}

export default GlobalNavHeader;
